import { useTranslation } from "react-i18next";

/** Progress bar while files upload (progress 0..1), else the error, else nothing. */
export default function UploadStatus({ progress, error }: { progress: number | null; error?: string | null }) {
  const { t } = useTranslation();

  if (progress !== null) {
    const percent = Math.round(progress * 100);
    return (
      <div
        className="flex flex-col gap-1"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={percent}
      >
        <div className="flex justify-between text-sm text-gray-600">
          <span>{t("files.uploading")}</span>
          <span>{percent}%</span>
        </div>
        <div className="h-2 rounded-full bg-orange-100 overflow-hidden">
          <div className="h-full bg-dobu-orange transition-[width]" style={{ width: `${percent}%` }} />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="rounded-md p-2 text-sm bg-red-200 text-red-900" role="alert">
        {error}
      </div>
    );
  }

  return null;
}
